import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ProfileProps {
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  token: string;
}

const Profile: React.FC<ProfileProps> = ({ setIsLoggedIn, token }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    setIsLoggedIn(false); // Update the login state to logged out
    localStorage.removeItem('token');
    navigate('/login');   // Redirect the user to the Login page
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8 }}>
      <Typography variant="h5" gutterBottom>
        Profile
      </Typography>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleLogout}
        sx={{ mt: 2 }}
      >
        Logout
      </Button>
    </Box>
  );
};

export default Profile;